// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "main-static/js/" + chunkId + "." + "931adf26" + ".chunk.js";
};